// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("./Store.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_AsyncData = require("relude/src/Relude_AsyncData.bs.js");

function MakeThunkHelpers(S) {
  var getAuthorizedClientForIO = S.getAuthorizedClientForIO;
  var getUnauthorizedClientForIO = S.getUnauthorizedClientForIO;
  var getClientForAuthType = function (authType, dispatch) {
    if (authType) {
      return getUnauthorizedClientForIO;
    } else {
      return Curry._1(getAuthorizedClientForIO, dispatch);
    }
  };
  var continuation = function (authTypeOpt, updateState, io, cont) {
    var authType = authTypeOpt !== undefined ? authTypeOpt : /* Required */0;
    return {
            TAG: /* Continuation */3,
            _0: updateState,
            _1: (function (state, dispatch) {
                return Relude_IO.flatMap((function (client) {
                              return Curry._3(io, state, dispatch, client);
                            }), Curry._1(getClientForAuthType(authType, dispatch), state));
              }),
            _2: cont
          };
  };
  var updateState = function (setData) {
    return {
            TAG: /* Continuation */3,
            _0: setData,
            _1: (function (param, param$1) {
                return Relude_IO.pure(undefined);
              }),
            _2: (function (param) {
                return Store.noUpdate;
              })
          };
  };
  var sideEffect = function (authTypeOpt, getNewValue) {
    var authType = authTypeOpt !== undefined ? authTypeOpt : /* Required */0;
    return {
            TAG: /* Continuation */3,
            _0: Relude_Globals.id,
            _1: (function (state, dispatch) {
                return Relude_IO.flatMap(Curry._2(getNewValue, state, dispatch), Curry._1(getClientForAuthType(authType, dispatch), state));
              }),
            _2: (function (param) {
                return Store.noUpdate;
              })
          };
  };
  var getAsyncResult = function (authTypeOpt, getData, setData, getNewValue) {
    var authType = authTypeOpt !== undefined ? authTypeOpt : /* Required */0;
    return {
            TAG: /* Continuation */3,
            _0: (function (state) {
                return Curry._2(setData, state, Relude_AsyncData.toBusy(Curry._1(getData, state)));
              }),
            _1: (function (state, dispatch) {
                return Curry._2(Relude_IO.mapError, (function (param) {
                              return /* Void */1;
                            }), Relude_IO.summonError(Relude_IO.flatMap(getNewValue, Curry._1(getClientForAuthType(authType, dispatch), state))));
              }),
            _2: (function (resultValue) {
                return {
                        TAG: /* Continuation */3,
                        _0: (function (state) {
                            return Curry._2(setData, state, Relude_AsyncData.pure(resultValue));
                          }),
                        _1: (function (param, param$1) {
                            return Relude_IO.pure(undefined);
                          }),
                        _2: (function (param) {
                            return Store.noUpdate;
                          })
                      };
              })
          };
  };
  var updateAsyncResult = function (getData, setData, state, result) {
    if (typeof result === "number") {
      if (result === /* Init */0) {
        return Store.noUpdate;
      } else {
        return Store.update(Curry._2(setData, state, Relude_AsyncData.toBusy(Curry._1(getData, state))));
      }
    }
    if (result.TAG === /* Reloading */0) {
      return Store.update(Curry._2(setData, state, result));
    }
    var error = result._0;
    if (error.TAG === /* Ok */0) {
      return Store.update(Curry._2(setData, state, result));
    }
    var error$1 = error._0;
    var __x = Curry._2(setData, state, result);
    return Store.updateWithSideEffects(__x, (function (_state, _dispatch) {
                  return Relude_IO.$$throw(error$1);
                }));
  };
  var loadAsyncData = function (authTypeOpt, onAsyncData, asyncDataLoader, state, dispatch) {
    var authType = authTypeOpt !== undefined ? authTypeOpt : /* Required */0;
    return Relude_IO.flatMap((function (param) {
                  return Relude_Globals.$great$great(asyncDataLoader, (function (param) {
                                return Relude_IO.flatMap((function (param) {
                                              return Relude_Globals.$great$great(onAsyncData, dispatch, param);
                                            }), param);
                              }), param);
                }), Relude_IO.flatMap((function (param) {
                      return Curry._1(getClientForAuthType(authType, dispatch), state);
                    }), Curry._1(dispatch, Curry._1(onAsyncData, /* Loading */1))));
  };
  var runAsyncMutation = function (authTypeOpt, onFinish, mutation, state, dispatch) {
    var authType = authTypeOpt !== undefined ? authTypeOpt : /* Required */0;
    return Relude_IO.flatMap((function (param) {
                  return Relude_Globals.$great$great(onFinish, dispatch, param);
                }), Relude_IO.flatMap(mutation, Curry._1(getClientForAuthType(authType, dispatch), state)));
  };
  var makeSubscriptionResponseHandler = function (onResultProcessed, dispatch, onResult) {
    var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
            
          }));
    var partial_arg$1 = Relude_Option.fold(Relude_IO.pure(undefined), (function (param) {
            return Relude_Globals.$great$great(dispatch, partial_arg, param);
          }), onResultProcessed);
    var partial_arg$2 = function (param) {
      return Relude_Globals.$$const(partial_arg$1, param);
    };
    var partial_arg$3 = function (param) {
      return Relude_IO.flatMap(partial_arg$2, param);
    };
    var partial_arg$4 = Curry._1(Relude_IO.mapError, (function (prim) {
            
          }));
    var partial_arg$5 = function (param) {
      return Relude_Globals.$great$great((function (param) {
                    return Relude_Globals.$great$great(onResult, dispatch, param);
                  }), partial_arg$4, param);
    };
    var partial_arg$6 = function (param) {
      return Relude_IO.flatMap(partial_arg$5, param);
    };
    var partial_arg$7 = Curry._1(Relude_IO.mapError, (function (prim) {
            
          }));
    var partial_arg$8 = function (param) {
      return Relude_Globals.$great$great(Relude_IO.fromResult, partial_arg$7, param);
    };
    var partial_arg$9 = function (param) {
      return Relude_Globals.$great$great(partial_arg$8, partial_arg$6, param);
    };
    return function (param) {
      return Relude_Globals.$great$great(partial_arg$9, partial_arg$3, param);
    };
  };
  var Lens = function (L) {
    var getAsyncResult$1 = function (getter, setter) {
      return function (param) {
        return getAsyncResult(undefined, (function (param) {
                      return Relude_Globals.$great$great(L.getter, getter, param);
                    }), (function (state, newValue) {
                      return Curry._2(L.setter, Curry._2(setter, Curry._1(L.getter, state), newValue), state);
                    }), param);
      };
    };
    var updateAsyncResult$1 = function (getter, setter) {
      return function (param, param$1) {
        return updateAsyncResult((function (param) {
                      return Relude_Globals.$great$great(L.getter, getter, param);
                    }), (function (state, newValue) {
                      return Curry._2(L.setter, Curry._2(setter, Curry._1(L.getter, state), newValue), state);
                    }), param, param$1);
      };
    };
    var loadAsyncData$1 = function (authType, actionLens) {
      return function (param, param$1, param$2) {
        return loadAsyncData(authType, (function (param) {
                      return Relude_Globals.$great$great(actionLens, L.actionWrapper, param);
                    }), param, param$1, param$2);
      };
    };
    var runAsyncMutation$1 = function (authType, actionLens) {
      return function (param, param$1, param$2) {
        return runAsyncMutation(authType, (function (param) {
                      return Relude_Globals.$great$great(actionLens, L.actionWrapper, param);
                    }), param, param$1, param$2);
      };
    };
    var makeSubscriptionResponseHandler$1 = function (onResultProcessed, onResult) {
      var arg = function (param) {
        return Relude_Globals.$great$great(onResult, L.actionWrapper, param);
      };
      return function (param) {
        return makeSubscriptionResponseHandler(Relude_Option.map(L.actionWrapper, onResultProcessed), param, arg);
      };
    };
    return {
            getter: L.getter,
            setter: L.setter,
            getAsyncResult: getAsyncResult$1,
            updateAsyncResult: updateAsyncResult$1,
            loadAsyncData: loadAsyncData$1,
            runAsyncMutation: runAsyncMutation$1,
            makeSubscriptionResponseHandler: makeSubscriptionResponseHandler$1
          };
  };
  return {
          getAuthorizedClientForIO: getAuthorizedClientForIO,
          getUnauthorizedClientForIO: getUnauthorizedClientForIO,
          getClientForAuthType: getClientForAuthType,
          continuation: continuation,
          updateState: updateState,
          sideEffect: sideEffect,
          getAsyncResult: getAsyncResult,
          updateAsyncResult: updateAsyncResult,
          loadAsyncData: loadAsyncData,
          runAsyncMutation: runAsyncMutation,
          makeSubscriptionResponseHandler: makeSubscriptionResponseHandler,
          Lens: Lens
        };
}

var graphQL = Store.graphQL;

var unauthorized = Store.unauthorized;

var known = Store.known;

var jsExn = Store.jsExn;

var $$void = Store.$$void;

var dispatchErrorToString = Store.dispatchErrorToString;

var summonAsyncStoreVoidError = Store.summonAsyncStoreVoidError;

var AsyncResultWithDispatchError = Store.AsyncResultWithDispatchError;

var IOWithDispatchError = Store.IOWithDispatchError;

var noUpdate = Store.noUpdate;

var update = Store.update;

var sideEffects = Store.sideEffects;

var updateWithSideEffects = Store.updateWithSideEffects;

var continuation = Store.continuation;

var make = Store.make;

var useStore = Store.useStore;

var Make = Store.Make;

exports.graphQL = graphQL;
exports.unauthorized = unauthorized;
exports.known = known;
exports.jsExn = jsExn;
exports.$$void = $$void;
exports.dispatchErrorToString = dispatchErrorToString;
exports.summonAsyncStoreVoidError = summonAsyncStoreVoidError;
exports.AsyncResultWithDispatchError = AsyncResultWithDispatchError;
exports.IOWithDispatchError = IOWithDispatchError;
exports.noUpdate = noUpdate;
exports.update = update;
exports.sideEffects = sideEffects;
exports.updateWithSideEffects = updateWithSideEffects;
exports.continuation = continuation;
exports.make = make;
exports.useStore = useStore;
exports.Make = Make;
exports.MakeThunkHelpers = MakeThunkHelpers;
/* Store Not a pure module */
